/**
 * ****************************************************************************
 * @description     :   Combinie all reducers on app
 * @created at      :   2022/07/13
 * @created by      :   
 * @package         :   dailyreportsystem
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * import libraries
 */
import { combineReducers } from 'redux';

/**
 * import reducer process for all child components
 */
import app from './app/reducer';
import report from './report/reducer';

/**
 * Combinie all reducers on app
 * -----------------------------------------
 * @author : create
 * @access : public
 */
const rootReducer = combineReducers({
    app,
    report
});
export default rootReducer;